import React, { Component } from "react";
import { connect } from 'react-redux';
import * as wActs from '../actions/website-actions'

class SeoHeaders extends Component {

  constructor(props) {
    super(props);
    this.state = {
      Position: props.Position,
      Helps: {
        "Tags": "none",
        "Path": "none",
        "Title": "none",
        "Keywords": "none",
        "Description": "none",
        "H1Text": "none",
        "H1TextBlock": "none"
      }
    }
  }

  componentDidMount() {
    if(this.state.Position === "Top" && this.showOnTop() && !wActs.isNullOrEmpty(this.props.WebPage.Page.H1TextBlock)) {
      this.TopSeo.innerHTML = this.props.WebPage.Page.H1TextBlock
    }
    if(this.state.Position === "Bottom" && this.showOnBottom() && !wActs.isNullOrEmpty(this.props.WebPage.Page.H1TextBlock)) {
      this.BottomSeo.innerHTML = this.props.WebPage.Page.H1TextBlock;
    }
  }


  smallWidth() {
    if(typeof window !== "undefined") {
      if(window.innerWidth < 767) {
        return true
      }
    } else {
      return false;
    }
    return false;
  }

  showOnTop() {
    return this.props.WebPage.Settings.SeoTextPosition === "Top" && !this.props.WebPage.ServerParams.IsMobile;
  }
  showOnBottom() {
    return this.props.WebPage.Settings.SeoTextPosition === "Bottom" || (this.props.WebPage.Settings.SeoMobileTextPosition === "Bottom" && (this.props.WebPage.ServerParams.IsMobile || this.smallWidth()));
  }

  render() {
    let seoCode = (
      <div>
        {this.state.Position === "Top" && !wActs.isNullOrEmpty(this.props.WebPage.Page.H1Text) &&
        <h1 className={"h1-top"} style={{marginBottom: "5px"}}>{this.props.WebPage.Page.H1Text}</h1>
        }
        {this.state.Position === "Top" && this.showOnTop() && !wActs.isNullOrEmpty(this.props.WebPage.Page.H1TextBlock) &&
        <p ref={(r) => {this.TopSeo = r}} className="h1textblock" style={{textAlign: "justify"}} dangerouslySetInnerHTML={{__html: this.props.WebPage.Page.H1TextBlock}}></p>
        }
        {this.state.Position === "Bottom" && this.showOnBottom() && !wActs.isNullOrEmpty(this.props.WebPage.Page.H1TextBlock) &&
        <p ref={(r) => {this.BottomSeo = r}} className="h1textblock" style={{textAlign: "justify", borderTop: "2px solid #e4e7e9", borderBottom: "2px solid #e4e7e9", padding: "10px"}} dangerouslySetInnerHTML={{__html: this.props.WebPage.Page.H1TextBlock}}></p>
        }
      </div>
    )

    //if (wActs.isNullOrEmpty(this.props.WebPage.Page.H1Text)) { seoCode = <div></div> }
    //if (this.props.WebPage.PageType === "profile" && this.smallWidth()) { seoCode = <div></div> }

    return (
      <div>
        {seoCode}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    WebPage: state.Website
  };
}

export default connect(mapStateToProps)(SeoHeaders);
